import jStat from 'jstat';
import type { TwoArrayParams } from './types';
import type { CorrelationResult } from '../../components/calculators/correlation-coefficient/correlation-coefficient-calculator';

/**
 * Calculates Pearson correlation coefficient and related statistics
 * @param params Object containing two arrays of data
 * @returns Object containing correlation coefficient, r-squared, p-value, and sample size
 */
export function calculateCorrelation({ data1, data2 }: TwoArrayParams): CorrelationResult {
  if (data1.length !== data2.length) {
    throw new Error('Arrays must have the same length');
  }

  const correlationCoefficient = jStat.corrcoeff(data1, data2);
  const rSquared = correlationCoefficient * correlationCoefficient;
  const sampleSize = data1.length;

  // Calculate t-statistic for significance testing
  const t = correlationCoefficient * Math.sqrt((sampleSize - 2) / (1 - rSquared));
  
  // Calculate p-value using Student's t-distribution
  // Two-tailed test, so we multiply by 2
  const pValue = 2 * (1 - jStat.studentt.cdf(Math.abs(t), sampleSize - 2));

  return {
    correlationCoefficient,
    rSquared,
    pValue,
    sampleSize,
    data1: Array.from(data1),
    data2: Array.from(data2)
  };
} 